import { Injectable } from '@angular/core';

import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

import { Integrante } from './integrante.model';

@Injectable({
  providedIn: 'root'
})
export class IntegranteService {
  url: string;
  token: string;
  endpoint: string = 'rpeIntegrantes';
  endpointUpdate: string = 'rpeUpdateIntegrantes';

  constructor(private http: HttpClient) { }

  geIntegrante(): Observable<Integrante[]> {
    return this.http.get<Integrante[]>(`${this.url}/${this.endpoint}/`, {
      params: { token: this.token }
    });
  }

  addIntegrante(integrante: Integrante): Observable<Integrante> {
    return this.http.post<Integrante>(`${this.url}/${this.endpoint}/`, {
      ...integrante
    });
  }

  changeIntegrante(i: Integrante): Observable<Integrante> {
    const fecha_baja = i.rol.fecha_baja
      ? i.rol.fecha_baja.toString().split('T')[0]
      : null;
    return this.http.patch<Integrante>(`${this.url}/${this.endpoint}/${i.rol.id}/`, {
      ...i,
      fecha_baja: fecha_baja
    });
  }

  //Baja logica
  // deleteIntegrante(p: Integrante): Observable<Integrante> {
  //   return this.http.delete<Integrante>(
  //     `${this.url}/${this.endpoint}/${p.id}`,
  //     {
  //       params: { token: this.token }
  //     }
  //   );
  // }
}
